import { string, object, array } from 'yup'

const ChildrenProfileSchema = object().shape({
  name: string().required('Name is required').trim(),
  age: string().nullable().required('Age is required'),
  interests: array().nullable().required('Choose your option(s)')
})

export default ChildrenProfileSchema
